import { Plugins } from '@leverege/plugin';
const TokenizerFactory = Plugins.createFactory('Expression.Tokenizer', {
  typeKey: 'type',
  pluginKey: 'tokenize',
  defaultObject: () => []
});
export default TokenizerFactory;